import { graphql, useStaticQuery } from "gatsby";
import React from 'react';
import { siteUrl } from "../../../utils/siteUrl";
import Button from '../../atoms/button/button';
import './favorite-products.scss';

const FavoriteProducts = props => {
  const resultQuery = useStaticQuery(
    graphql`
          query PATERN_INFO{
            allContentfulNolHomeTercerNivel(filter: { slug: {eq: "cuidado-femenino"}}) {
              nodes {
                node_locale
                imagenProductosRecomendados {
                  file {
                    url
                  }
                  description
                }
              }
            }
          }
        `
  )

  const imgFavoriteProducts = resultQuery.allContentfulNolHomeTercerNivel.nodes.filter(e => e.node_locale === process.env.LOCALE)[0].imagenProductosRecomendados;

  return (
    <section className="f-section-favorite-products">
      <div className="f-conten-info">
        <div className="f-titles-container">
          <label className="f-label-regular">
            Compra tus productos favoritos
                    </label>
          <label className="f-chewy-title">
            de Nosotras a un solo clic
                    </label>

        </div>
        <a href={siteUrl + '/productos/tiendas'}>
          <Button
            className="secondary-pink short"
            title='Comprar'
          />
        </a>
        {!props.mobile &&
          <img
            className="f-favorite-img-products"
            src={imgFavoriteProducts.file.url}
            alt={imgFavoriteProducts.description}
          />
        }

      </div>

      {/* <div className="curve-effect"></div> */}
    </section>
  )
}

export default FavoriteProducts
